<template>
    <div>
        <el-input v-if="isEditing" v-model="comments" maxlength="200" class="search-InputBox" size="mini" :placeholder="comments"></el-input>
        <el-button v-if="isEditing" icon="el-icon-success" class="margin-left-10" size="small" type="text" @click="saveComment()"></el-button>
        <el-button v-if="isEditing" icon="el-icon-error" class="gray" size="small" type="text" @click="Reset()"></el-button>
        <span v-if="!isEditing" :class="{'cs-color-frenchgrey' : !comments }">
            {{!comments?"双击填写评语":comments}}
        </span>
    </div>
</template>

<style lang="scss" scoped>
.cs-accountList-payment {
    span {
        display: inline-block;
        margin-right: 1px;
    }
}

.gray {
    color: gray;
    margin-left: 3px;
}

.margin-left-10 {
    margin-left: 10px;
}

.search-InputBox {
    width: 140px;
}
</style>

<script>
import {
    commentHomework
} from "../../../service/homework.service.js"
export default {
    props: {
        data: {},
        columnData: {},
        status: {},
        editLocation: {},
    },
    data() {
        return {
            canEdit: true,
            id:0,
            comments: null,
            HasFile:true,
            isEditing: false,
            originaComments: ""
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data){
                this.comments = this.data.Comment;
                this.id = this.data.Id;
                this.originaComments = this.comments;
                this.HasFile = this.data.HasFile;
                this.canEdit = this.data.CanEdit;
            }
        },
        saveComment() {
            let self = this;
            if (!this.HasFile) {
                this.$message.error("作业未提交，无法更新评语");
            } else {
                commentHomework(this.id, this.comments)
                    .then(result => {
                        if (!!result && result.success) {
                            this.$message({
                                type: 'success',
                                message: '评语更新成功!'
                            });
                            self.originaComments = self.comments;
                            self.Reset();
                        } else {
                            self.Reset();
                            this.$message({
                                type: 'error',
                                message: '评语更新失败! ' + result.message
                            });
                        }
                    })
            }
        },
        Reset() {
            this.isEditing = false;
            this.comments = this.originaComments;
        }
    },
    watch: {
        editLocation: function() {
            if (!this.canEdit){
                return;
            }
            if (this.editLocation && this.editLocation.columnLabel == "评语" && this.editLocation.Id == this.data.Id) {
                this.isEditing = true;
            } else {
                this.isEditing = false;
            }
        },
        data: function() {
            this.init();
        },
        status: function() {}
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkCommentCell.vue